import ExportUnitsGrid from '@/components/exportUnits/ExportUnitsGrid';
import { exportUnitsActions, useExportUnitSettings } from '@/stores/exportUnitsStore';

const ExportUnitsRoute = () => {
  const settings = useExportUnitSettings();

  return (
    <div className="max-w-2xl">
      <div className="mb-2 text-lg font-medium">Export Units</div>
      <ExportUnitsGrid
        caption="Your preferred units for Excel exports. New projects you create start with these, and a project's units can be changed in its Control Panel."
        settings={settings}
        onSave={exportUnitsActions.updateAccount}
      />
    </div>
  );
};

export default ExportUnitsRoute;
